import { DatePicker, TimePicker } from "antd";
import AntDatePicker from "./styles/datePicker.style";

const Datepicker = AntDatePicker(DatePicker);
const TimeRangePicker = AntDatePicker(TimePicker.RangePicker);
const DateRangepicker = DatePicker.RangePicker;

export default Datepicker;
export { DateRangepicker, TimeRangePicker };
